export default {
  DatabaseId: 'x-mmo-db-id',
  BudgetCode: 'x-mmo-bc'
}